import TypeError from '../errors/TypeError';
import NotImplementedError from '../errors/NotImplementedError';
import GoogleAnalytics from '../google/GoogleAnalytics';
export default class PlotFilterer{
	constructor(props){
		this._filters = [];
	}
	addPlotFilter(plotFilter){
		const filterPlots = plotFilter.filterPlots;
		if(filterPlots===undefined||filterPlots===null)
			throw new NotImplementedError(`The object of type ${plotFilter.constructor.name} did not have a .filterPlots method`);
		if(typeof(filterPlots)!=='function')
			throw new TypeError('${plotFilter.constructor.name}.filterPlots was not a function');
		this._filters.push(plotFilter);
	}
	get filtersApplied(){
		const filters = this._filters;
		for(var i=0; i<filters.length; i++){
			const filter = filters[i];
			if(filter.isApplied)return true;
		}
		return false;
	}
	clearFilters(){
		this._filters.forEach((filter)=>filter.clear());
	}
	filterPlots(plots){
		const filterNames =[];
		this._filters.forEach((filter)=>{
			plots = filter.filterPlots(plots);
			if(filter.isApplied);
				filterNames.push(filter.menuType);
		});
		GoogleAnalytics.logEvent('filteredPlots', {appliedFilterNames:filterNames, remainingPlotNumbers:plots.map(plot=>plot.number)});
		return plots;	
	}
}
